import React, {Component} from 'react';
import $ from 'jquery';
import {FormattedMessage} from "react-intl";

import {getCurrentLayout} from '../appLayout';
import SelectionFooterSubPart from "./selectionFooterSubPart";
import ActionTypes from "../../misc/actionTypes";
import BodySwipable from "../visComponents/navigation/desktop/bodySwipable";
import LoadingSpinner from "../ui/loadingSpinner";

export default class SelectionFooterSubParts extends Component {

  constructor(props) {
    super(props);
    this.state = {
      relatedItems: [],
      shadowLeft: -100,
      shadowRight: 0,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.setRelatedItems(this.props);
    // this.footerList.addEventListener("scroll", this.handleFooterListScroll);
    $(window).on(ActionTypes.UPDATE_ALL_ITEMS, this.updateItems);
    setTimeout(() => {
      this.scrollToActiveSubPart(this.props.activePartRelatedItemIndex, 0);
    }, 0)
  }

  componentWillUnmount() {
    $(window).off(ActionTypes.UPDATE_ALL_ITEMS, this.updateItems);
    // this.footerList.removeEventListener("scroll", this.handleFooterListScroll);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.visualizerIsChanging && !nextProps.visualizerIsChanging) {
      this.setRelatedItems(nextProps);
    }
  }

  scrollToActiveSubPart = (activePartRelatedItemIndex, animationTime = 500) => {
    if (this.footerList) {
      const maxScroll = this.footerList.scrollWidth - this.footerList.clientWidth;
      const scrollIndex = this.props.windowWidth < 991 ? 50 : 40;
      const neededScroll = scrollIndex*activePartRelatedItemIndex;
      const scrollLeft = (maxScroll > 0) && (neededScroll > maxScroll) ? maxScroll : neededScroll;
      $(this.footerList).animate({scrollLeft}, animationTime);
    }
  };

  handleFooterListScroll = (e) => {
    // console.log('e', e.target.scrollLeft);
    this.setState({
      shadowLeft: e.target.scrollLeft > 100 ? 0 : -100 + e.target.scrollLeft,
      shadowRight: e.target.scrollLeft > 100 ? -100 : 0 - e.target.scrollLeft
    });
  };

  updateItems = () => {
    this.setRelatedItems(this.props)
  };

  setRelatedItems = (nextProps = this.props) => {
    // console.log('nextProps.activePart', nextProps.activePart);
    // console.log('activePart.subParts(false)', activePart.subParts(false));
    const layout = getCurrentLayout();
    // console.log("setRelatedItems layout", layout);
    if (layout.qtCategories && nextProps.qtActiveCategory) {
      const qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === nextProps.qtActiveCategory)
        || layout.qtCategories[0]; // cases when visualizerType is changed
      const currentSubParts = qtActiveCategory.subParts;
      this.setState({
        relatedItems: currentSubParts,
        isLoading: layout.isNewLayout
          && currentSubParts[0]
          && qtActiveCategory.defaultSubParts[0]
          && (qtActiveCategory.defaultSubParts[0].part.partId !== currentSubParts[0].part.partId)
          && !qtActiveCategory.defaultSubParts[0].part.allFeaturesReceived,
          // set loader true if first subPart is not loaded yet, mb it has some qt "on" items.
          // request should be in the visualizer.js // only for new kitchens, the old ones don't seem to have this issue
      });
    } else {
      this.setState({
        relatedItems: nextProps.activePart.subParts(false)
      });
    }
  };

  getSubPartsList = (withShoppingCart = false) => {
    const {activePartRelatedItemIndex, showAdvancedQuoting, visualizersLoaded, networkConnection} = this.props;
    return (
      <BodySwipable className="selection-footer-cell" scrollableSelector={".selection-footer-list"}>
        {/*<div className="selection-footer-cell__shadow selection-footer-cell__shadow--left"*/}
        {/*     style={{ left: this.state.shadowLeft }}/>*/}
        <div className="selection-footer-list" ref={(el) => this.footerList = el}>
          {this.state.isLoading || !visualizersLoaded.includes(document.kvConfig.visualizerType)
            ? <LoadingSpinner size="40" style={{backgroundPosition: "left 8px center"}}/>
            : this.state.relatedItems.map((item, index) => {
            if (showAdvancedQuoting && (index !== activePartRelatedItemIndex) && window.location.href.includes("materials")) {
              return null
            }
            if (item.part && item.part.partId === "slabs") {
              return null
            }
            return <SelectionFooterSubPart navItem={item}
                                           itemIndex={index}
                                           activePartRelatedItemIndex={activePartRelatedItemIndex}
                                           withShoppingCart={withShoppingCart}
                                           handleFooterButtonClick={this.handleFooterButtonClick}
                                           key={"footerButton"+index}/>
          })}
          {withShoppingCart ? (
            <button className="selection-footer-list__item selection-footer-list__item--cart selection-footer-list__item--active"
              // onClick={() => { this.props.handleCloseClick("shoppingcart") }}>
                    onClick={() => {}}>
              <span className="selection-footer-list__item-icon"/>
              {!networkConnection ? null : (
                <span className="selection-footer-list__item-items">{this.props.cartItems.length}</span>
              )}
              <span className="selection-footer-list__item-text">
                <FormattedMessage id="quotingTool.footer.cartFeatureGroupButton"/>
              </span>
            </button>
          ) : null}
        </div>
        {/*<div className="selection-footer-cell__shadow selection-footer-cell__shadow--right"*/}
        {/*     style={{ right: this.state.shadowRight }}/>*/}
      </BodySwipable>
    )
  }
}
